<template>

  <div class="home">
    <Navbar :is-active="5"></Navbar>
    <div class="body">
      <div class="body__sidebar" id="body__sidebar">
        <hidden-arrow></hidden-arrow>
        <div class="title">
          <div class="title__icon">
            <i class="fas fa-home"></i>
          </div>
          <div class="title__text">
              <h2>Menu QuickPay</h2>
            <p>Selecciona una opción</p>
          </div>
        </div>
        <div class="tabs">
          <router-link to="/UsuariosB2B" class="tab active">
            <div class="tab__icon">
              <i class="fas fa-globe"></i>
            </div>
            <div class="tab__text">
              <p>Usuarios B2B</p>
            </div>
          </router-link>
          <router-link to="/UsuariosB2C" class="tab ">
            <div class="tab__icon">
              <i class="fas fa-shopping-bag"></i>
            </div>
            <div class="tab__text">
              <p>Usuarios B2C</p>
            </div>
          </router-link>
        </div>
      </div>
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Usuario B2B / <span>Nuevo Usuario</span></h2>
        </div>
        <div class="page__subtitle">
          <h3>Información del Usuario</h3>
        </div>
        
        <form class="form" @submit.prevent="handleSubmit">
        <section class="page__filters first">
          <div class="input">
            <p>N° documento</p>
            <input type="text" v-model="user_doc_number">
          </div>
          <div class="input">
            <p>Nombre</p>
            <input type="text" v-model="user_name">
          </div>
          <div class="input">
            <p>Apellido</p>
            <input type="text" v-model="usar_lastname">
          </div>
          <div class="input">
            <p>Código país</p>
            <input type="text" v-model="cellphone_code">
          </div>
          <div class="input">
            <p>Celular</p>
            <input type="text" v-model="cellphone">
          </div>
          <div class="input">
            <p>Fecha de nacimiento</p>
            <input type="date" v-model="birthday_date">
          </div>
          <div class="input">
            <p>Correo</p>
            <input type="email" v-model="email">
          </div>
          <div class="input">
            <p>Contraseña</p>
            <input type="password" v-model="password">
          </div>
          <div class="input">
            <p>Repetir contraseña</p>
            <input type="password" v-model="password_confirmation">
          </div>

        </section>
        <section class="page__actionss">
          <a @click="exit()" class="cancel_button">
            <span style="color: white;">Cancelar</span>
            <i class="fa fa-times-circle"></i>
          </a>
          <button>
            <span>Guardar</span>
            <i class="fa fa-circle-check"></i>
          </button>
        </section>
        </form>


      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import axios from "axios";
import OpenArrow from '@/components/OpenArrow.vue';
import HiddenArrow from '@/components/HiddenArrow.vue';

export default {
  name: 'AddAdminUserB2B',
  components: {
    OpenArrow,
    HiddenArrow,
    Navbar
  },
  data() {
    return {
      user: '',
      show1: false,
      show2: false,
      user_doc_number: '',
      user_code: '',
      user_name: '',
      user_lastname: '',
      email: '',
      password: '',
      password_confirmation: '',
      cellphone_code: '',
      cellphone: '',
      birthday_date: '',
      usuario: '',
      fecha: '',
      idParams: ''
    }
  },
  created(){
    const valores = window.location.search;
    const urlParams = new URLSearchParams(valores);
    this.idParams = urlParams.get('id');
    this.getDate();
    this.usuario = localStorage.getItem('usuario');
  },
  methods:{
    exit(){
        this.$router.push({ path: '/AdminAddClientB2C', query: { id: this.idParams }})

    },
    zeroFill(number, width) {
        width -= number.toString().length
        if (width > 0) {
          return (
              new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
          )
        }
        return number + ''
    },
    getDate() {
      let dias = [
        'Lunes',
        'Martes',
        'Miercoles',
        'Jueves',
        'Viernes',
        'Sabado',
        'Domingo'
      ]
      let meses = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
      ]

      let date = new Date()

      const fechaNum = date.getDate()
      const mes_name = date.getMonth()

      let day = date.getDay() === 0 ? 6 : date.getDay() - 1
      this.fecha = dias[day] + ' ' + this.zeroFill(fechaNum, 2) + ' de ' + meses[mes_name]
    },
    showPasswrd1(){
      if(this.show1 === true){
        this.show1 = false
      }else {
        this.show1 = true
      }
    },
    showPasswrd2(){
      if(this.show2 === true){
        this.show2 = false
      }else {
        this.show2 = true
      }
    },
    handleClick(){
      localStorage.removeItem('token')
      this.$router.push('/login')
    },
    async handleSubmit(){
        const valores = window.location.search;
        const urlParams = new URLSearchParams(valores);
        const id = urlParams.get('id');
        const data ={
          "user_doc_type_id": 1,
          "password_confirmation": this.password_confirmation,
          "password": this.password,
          "email": this.email,
          "birthday_date": this.birthday_date,
          "cellphone": this.cellphone,
          "cellphone_code": this.cellphone_code,
          "user_lastname": this.usar_lastname,
          "user_name": this.user_name,
          "user_doc_number": this.user_doc_number,
          "company_id": id
        }
        console.log('aa');


        axios.post('register',data).then(res => {
          console.log(res);
          this.$swal({
                position: 'center',
                icon: 'success',
                title: 'Usuario B2B creado correctamente',
                showConfirmButton: false,
                timer: 2000
              })
              this.$router.push({ path: '/AdminAddClientB2C', query: { id: this.idParams }})
        }).catch(err => {
            this.$swal({
              position: 'center',
              icon: 'error',
              title: err.response.data.message,
              showConfirmButton: false,
              timer: 2000
            })
        });
    },
    changePage(url) {
      this.$router.push(url)
    },
  },
}


</script>

<style scoped>
#input_file {
  cursor: pointer;
  margin: 0;
  opacity: 0;
  outline: 0 none;
  padding: 0;
  position: absolute;
}
/*------NAVBAR------*/
.home {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Readex Pro', sans-serif;
}

.home .navbar {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #dbdbdb;
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.05);
}

.home .navbar__left {
  width: 10%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home .navbar__left img {
  width: 130px;
}

.home .navbar__center {
  width: 70%;
  height: 100%;
}

.home .navbar__center ul{
  width: 100%;
  height: 100%;
  display: flex;
  list-style: none;
  display: flex;
  justify-content: flex-start;
}
.home .navbar__center ul li {
  text-decoration: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  position: relative;
  cursor: pointer;
}

.home .navbar__center ul li::before {
  content: '';
  position: absolute;
  bottom: 0;
  width: 0;
  height: 4px;
  background-color: #ff3128;
  transition: .3s ease;
}
.home .navbar__center ul li:hover {
  color: #ff3128;
}
.home .navbar__center ul li:hover::before {
  width: 100%;
}

.home .navbar__right {
  display: flex;
  width: 20%;
}
.home .navbar__right .profile {
  display: flex;
  width: 100%;
  height: 100%;
}

.home .navbar__right .profile__detail{
  width: 220px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5px;
}
.home .navbar__right .profile__detail p {
  margin: 0;
}
.home .navbar__right .profile__detail span {
  color: #938f8f;
  font-weight: 300;

}

.home .navbar__right .profile__icon,
.home .navbar__right .profile__logout {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: #ff3128;
  cursor: pointer;
}
/*------NAVBAR------*/

/*-------------------------*/
a:hover {
  text-decoration: none;
}
/*-------------------------*/

.form__inputs {
  width: 100%;
  height: 100%;
  display: flex;
  margin-top: 20px;
  /*flex-direction: column;*/
  flex-wrap: wrap;
  align-content: flex-start;
}

.form__inputs .input {
  width: 49%;
  height: 10%;
  margin: 6px auto;
  /*margin-bottom: 4px;*/
  border: 1px solid #f1f1f1;
  border-radius: 15px;
  /*padding: 15px;*/
  display: flex;
  align-items: center;
  /*justify-content: space-between;*/
  justify-content: center;
}

.form__inputs .input input {
  border: none;
}
.page__actionss{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 30px 0;
  gap: 20px;
}
.cancel_button svg{
  color: white;
}
.cancel_button{
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border: none;
  border-radius: 15px;
  color: #fff;
  transition: 0.4s ease;
  background-color: #ff3128;
  cursor: pointer;
}
.cancel_button:hover{
  transform: scale(1.1);
}
.page__actionss button{
   width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border: none;
  border-radius: 15px;
  color: #fff;
  transition: 0.4s ease;
  background-color: #32ba7c;
}
.page__actionss button:hover{
  transform: scale(1.1);
}
.form__inputs .remember_account {
  width: 85%;
  margin: 15px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form__inputs .remember_account p {
  margin: 0;
}

@media (max-width: 768px) {
  .form__inputs {
    width: 75%;
    height: 100%;
    display: flex;
    margin-top: 20px;
    align-content: flex-start;
    flex-direction: column;
    flex-wrap: nowrap;
  }
  .form__inputs .input {
    width: 80%;
    height: 10%;
    margin: 6px auto;
    /*margin-bottom: 4px;*/
    border: 1px solid #f1f1f1;
    border-radius: 15px;
    /*padding: 15px;*/
    display: flex;
    align-items: center;
    /*justify-content: space-between;*/
    justify-content: center;
  }
}

/*------BODY------*/

.body {
  width: 100%;
  height: 600px;
  display: flex;
}
.body__sidebar,
.body__containt  {
  height: calc(100vh - 120px);
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
}
.body__sidebar {
  width: 400px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.body__sidebar .floating-icon {
  position: absolute;
  right: -15px;
  top: 30px;
  color: #ff3128;
  font-size: 30px;
}

.body__sidebar .title {
  width: 100%;
  height: 140px;
  border-bottom: 1px solid #b6b6b6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.body__sidebar .title__icon {
  color: #ff3128;
  font-size: 20px;
}
.body__sidebar .title__text {
  margin: 0 10px;

}

.body__sidebar .title__text h2 {
  font-size: 20px;
  margin: 0;
}
.body__sidebar .title__text p {
  margin: 0;
  font-weight: 300;
}

.body__sidebar .tabs {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 140px);
  padding-top: 5px;
}

.body__sidebar .tabs .tab {
  width: 90%;
  height: 70px;
  border-radius: 10px;
  color: #707070;
  display: flex;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: 0.3 ease;
}
.body__sidebar .tabs .tab:hover,
.body__sidebar .tabs .tab.active {
  color: #ff3128;
  background: #ffeeed;
}
.home .navbar__center ul li.active {
  color: #ff3128;
}
.home .navbar__center ul li.active::before {
  width: 100%;
}

.body__sidebar .tabs .tab__icon {
  font-size: 20px;
  margin-right: 10px;
}

.body__sidebar .tabs .tab__text p{
  margin: 0;
  font-weight: 600;
}
/*----------------------------*/
/*----------------------------*/
/*----------------------------*/
.body__containt {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  overflow-y: scroll;
}
.body__containt .page__subtitle,
.body__containt .page__title {
  width: 100%;
  margin-bottom: 20px;
}

.body__containt .page__title h2 {
  font-weight: 600;
  color: #000;
  font-size: 25px;
}
.body__containt .page__title h2 span {
  color: #ff3128;
}
.body__containt .page__subtitle h3  {
  color: #ff3128;
  font-weight: 600;
  font-size: 20px;
}

/*-----FILTERS------*/

.body__containt .page__filters {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  padding-bottom: 50px;
}

.body__containt .page__filters .input {
  width: 300px;
  border-radius: 10px;
  border: 1px solid #938f8f;
  display: flex;
  flex-direction: column;
  padding: 7px 15px;
  transition: 0.4s ease;

}

.body__containt .page__filters .input:hover {
  box-shadow: 10px 15px 15px rgba(0, 0, 0, 0.05);
}


.body__containt .page__filters .input span {
  font-size: 15px;
  color: #938f8f;
}
.body__containt .page__filters .input p {
  margin: 0;
}

.page__filters input, select, textarea{
  outline:none;
  border: none;
  background: white;
}

/*-----PRODUCT------*/
.page__product {
  width: 100%;
  display: flex;
}

.page__product .product__image,
.page__product .product__buttons {
  /* width: 50%; */
  display: flex;
  align-items: center;
}
.page__product .product__image {
  width: 400px;
  justify-content: center;
  border-radius: 10px;
  overflow: hidden;
}

.page__product .product__image img {
  width: 100%;
  object-fit: cover;
  transition: 1s ease;
}
.page__product .product__image img:hover {
  transform: scale(1.1) rotate(1deg);
}
.page__product .product__buttons {
  width: 500px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.page__actions button,
.page__product .product__buttons button {
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border: none;
  border-radius: 15px;
  color: #fff;
  transition: 0.4s ease;
}
.page__actions button:hover,
.page__product .product__buttons button:hover {
  transform: scale(1.1);
}
.page__actions button:nth-child(2),
.page__product .product__buttons button:nth-child(1) {
  background: #32ba7c;
}
.page__product .product__buttons button:nth-child(2) {
  background: #262626;
}
.page__product .product__buttons button:hover:nth-child(2) {
  background: #ff3128;
}

/*------------------------*/
/*------------------------*/
/*------------------------*/

.page__actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 30px 0;
  gap: 20px;
}

.page__actions button:nth-child(1) {
  background: #ff3128;
}

/*------BODY------*/
/*TABLA*/
.body__containt .page__table {
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  margin-top: 50px;
}
.body__containt .page__table .table-headers {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-evenly;
  border-bottom: 1px solid #b6b6b6;
}
.body__containt .page__table .table-headers p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  white-space: nowrap;
}
.body__containt .page__table .table-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #b6b6b6;
}
.body__containt .page__table .table-body .data {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
.body__containt .page__table .table-body .data p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
  margin: 10px 0;
}
.body__containt .page__table .table-body .data p:nth-child(1) {
  color: #ff3128;
}
.lista_productos__buttons button{
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border: none;
  border-radius: 15px;
  color: #fff;
  transition: 0.4s ease;
}
.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 20px;
  margin-bottom: 0px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 17px;
  left: 2px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}
input:checked + .slider {
  background-color: #32ba7c;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}
input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.body__sidebar.open{
  display: none;
}
</style>
